export default __webpack_public_path__ + "static/media/servicenow.45935a80.svg";